import { apiClient } from "helpers/api_helper";

export const getAllCategoryData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Category/GetAllCategory`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};